import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mentors: [],
};

export const mentorsSlice = createSlice({
  name: "mentors",
  initialState,
  reducers: {
    updateMentors: (state, action) => {
      state.mentors = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateMentors } = mentorsSlice.actions;
export default mentorsSlice.reducer;
